import { DeviceConfigParams } from "../../DeviceConfigParams";
export class PirSensorParams extends DeviceConfigParams {
    constructor() {
        super(...arguments);
        this.DetectionThreshold = 223;
        this.WindowTime = 2;
        this.Detection = 2;
        this.PredefinedSettings = 7;
    }
}
export class MovementDetectorParams extends DeviceConfigParams {
    constructor() {
        super(...arguments);
        this.OffTime = 20;
        this.LuxSetting = 0;
        this.CurrentLuxValue = 0;
        this.SyncTime = 720;
        this.AccEvent = false;
        this.AccLevel = AccLevel.Medium;
        this.SensorMode = MoveSensorMode.NoBrightnessSensor;
        this.ExternalOutMode = MoveSensorExternalOutputMode.NO;
        this.OpticalLEDSignalization = true;
        this.MoveLEDSignalization = false;
    }
}
export var AccLevel;
(function (AccLevel) {
    AccLevel[AccLevel["Low"] = 0] = "Low";
    AccLevel[AccLevel["Medium"] = 1] = "Medium";
    AccLevel[AccLevel["High"] = 2] = "High";
})(AccLevel || (AccLevel = {}));
export var MoveSensorMode;
(function (MoveSensorMode) {
    MoveSensorMode[MoveSensorMode["NoBrightnessSensor"] = 0] = "NoBrightnessSensor";
    MoveSensorMode[MoveSensorMode["NightMode"] = 1] = "NightMode";
    MoveSensorMode[MoveSensorMode["DayMode"] = 2] = "DayMode";
})(MoveSensorMode || (MoveSensorMode = {}));
export var MoveSensorExternalOutputMode;
(function (MoveSensorExternalOutputMode) {
    MoveSensorExternalOutputMode[MoveSensorExternalOutputMode["NO"] = 0] = "NO";
    MoveSensorExternalOutputMode[MoveSensorExternalOutputMode["NC"] = 1] = "NC";
    MoveSensorExternalOutputMode[MoveSensorExternalOutputMode["Disable"] = 2] = "Disable";
})(MoveSensorExternalOutputMode || (MoveSensorExternalOutputMode = {}));
//# sourceMappingURL=Rcr21ConfigParams.js.map